import React from "react";
import Pricing from "shared/components/Pricing";
import filterImagesForCoverImage from "shared/utils/filters/productImageFilter";
import RemainingTime from "shared/components/RemainingTime";
import { Row, Col } from "react-bootstrap";

export default class ProductSlide extends React.Component {
  constructor(props) {
    super(props);

    const tmpCoverImageUrl = filterImagesForCoverImage(props.product.images);
    this.state = {
      coverImageUrl: tmpCoverImageUrl,
    };
  }

  truncateString(str, num) {
    if (str !== undefined && num !== undefined) {
      return str.length > num
        ? `${str.slice(0, num > 3 ? num - 3 : num)}...`
        : str;
    }
    return "";
  }

  render() {
    const { product } = this.props;

    const divStyle = {
      color: "blue",
      backgroundImage: `url(${this.state.coverImageUrl})`,
    };

    return (
      <div className="startup-product-slide-card">
        <Row>
          <Col xs={6}>
            <div className="publishedOn">
              <RemainingTime product={product} />
            </div>
          </Col>
        </Row>
        <a href={this.props.url} key={product.id}>
          <div className="productImage" style={divStyle} />
          <Row>
            <Col xs={12}>
              <h4>{this.truncateString(product.name, 25)}</h4>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Pricing product={product} />
            </Col>
          </Row>
        </a>
        <Row className="startup-product-slide-link-group">
          <StartupShowProductDetailLink product={product} />
          <StartupEditProductLink product={product} />
          <StartupShowProductWeeklySalesLink product={product} />
        </Row>
      </div>
    );
  }
}

const StartupProductSlideLink = ({ linkText, linkUrl }) => {
  return (
    <Row className="startup-product-slide-link">
      <Col xs={12} className="text-center">
        <a href={linkUrl}>{linkText}</a>
      </Col>
    </Row>
  );
};

const StartupShowProductDetailLink = ({
  product,
  showProductDetailLinkUrl,
}) => {
  return (
    <StartupProductSlideLink
      linkText={<span>ZUR DETAILSEITE</span>}
      linkUrl={
        showProductDetailLinkUrl ||
        `${window.location.origin}/startups/products/${product.id}`
      }
    />
  );
};

const StartupEditProductLink = ({ product, editProductLinkUrl }) => {
  return (
    <StartupProductSlideLink
      linkText={<span>Produkt editieren</span>}
      linkUrl={
        editProductLinkUrl ||
        `${window.location.origin}/startups/products/${product.id}/edit`
      }
    />
  );
};

const StartupShowProductWeeklySalesLink = ({
  product,
  showProductWeeklySalesLinkUrl,
}) => {
  if (!product.isLive) {
    return null;
  }

  return (
    <StartupProductSlideLink
      linkText={<span>Abverkaufszahlen ansehen</span>}
      linkUrl={
        showProductWeeklySalesLinkUrl ||
        `${window.location.origin}/startups/products/${product.id}/chart`
      }
    />
  );
};
